<template>
  <section class="hero is-fullheight" style="height: auto !important;">
    <DashBoardHeader :PCTRLLOG="CTRLLOG"></DashBoardHeader>
    <DashBoardBody></DashBoardBody>
  </section>
</template>

<script>
import DashBoardHeader from '@/views/DashBoard/DashBoardHeader'
import DashBoardBody from '@/views/DashBoard/DashBoardBody'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'DashBoard',
  components: {
    DashBoardHeader,
    DashBoardBody
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      COMPONENT_NAME: 'DashBoard'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/DashBoard.vue